import React from 'react';
import { Form } from 'react-bootstrap';

import { lazyWithRetry } from 'utils/lazy-with-retry';

const NumberFormat = lazyWithRetry(() => import('react-number-format'));

const MoneyFormControl = (props: any) => {
    return (
        // @ts-ignore
        <NumberFormat
            {...props}
            customInput={Form.Control}
            thousandSeparator={true}
            prefix="$"
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            maxLength={14}
        />
    );
};

export default MoneyFormControl;
